export default __webpack_public_path__ + "static/midas-4223410126b59a99879ce75c39f2b4c029115d8cf9cd00d2627a54b3a42d2a90.png";